export default {
    ':root': [
        // {
        // 	title: '动态配置',
        // 	type: 'switch',
        // 	value: {
        // 		get({ data }) {
        // 			return data.dynamic
        // 		},
        // 		set({ data }, value) {
        // 			data.dynamic = value;
        // 		}
        // 	}
        // },
        {
            title: '小程序AppID',
            desc: "请务必保持生成和解析使用同一个密钥",
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.appId;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.appId = value;
                }
            }
        },
        {
            title: '小程序AppSecret',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.appSecret;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.appSecret = value;
                }
            }
        },
    ]
};
